import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'reactstrap'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import { ButtonClose } from 'Stories/Icon/Icon.stories'

import LanguageHint from '../LanguageHint'

import { LanguageHintModalProps } from './LanguageHintModalProps'

import {
  GotItBtnContainer,
  LanguageHintModalHeader,
  LanguageHintModalHeaderBtn,
} from './styles'

const LanguageHintModal: FunctionComponent<LanguageHintModalProps> = ({
  toggle,
  isOpen,
}) => {
  const { t } = useTranslation()

  const onModalClose = () => {
    toggle(false)
  }
  return (
    <Modal
      fade={false}
      className="modal-dialog modal-dialog--header promocode"
      isOpen={isOpen}
      modalClassName="ltr-support"
      toggle={onModalClose}
    >
      <LanguageHintModalHeader>
        <LanguageHintModalHeaderBtn type="button" onClick={onModalClose}>
          <ButtonClose />
        </LanguageHintModalHeaderBtn>
      </LanguageHintModalHeader>
      <LanguageHint />
      <GotItBtnContainer>
        <WhiteGreenBtn color="white" onClick={onModalClose}>
          {t('scheduleCampaignPage.gotIt')}
        </WhiteGreenBtn>
      </GotItBtnContainer>
    </Modal>
  )
}
export default LanguageHintModal
